<ng-container *transloco="let t">
    <div class="flex flex-col flex-auto h-full overflow-hidden sm:overflow-y-auto">
        <div class="grid">
            <!-- Header -->
            <div *ngIf="enableSort && !socials" #sort="matSort" matSort [matSortActive]="!onlyStreams ? 'revenue' : 'streams'" matSortDirection="desc"
                matSortStart="desc" matSortDisableClear
                [ngClass]="{'inventory-grid': !onlyStreams && showPPS, 'inventory-grid-no-pps': !onlyStreams && !showPPS, 'inventory-grid-only-streams': onlyStreams}"
                class="z-10 sticky top-0 grid gap-4 py-4 px-4 sm:px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                <div></div>
                <div class="hidden lg:block"></div>
                <div></div>
                <div>
                    {{t('title')}}
                </div>
                <div class="text-right hidden md:block" [mat-sort-header]="'streams'" arrowPosition="before">
                    {{!onlyStreams ? ('streams' | transloco) : ('artificial-streams' | transloco)}}
                </div>
                <div *ngIf="!onlyStreams" class="text-right hidden md:block" [mat-sort-header]="'downloads'" arrowPosition="before">
                    {{t('downloads')}}
                </div>
                <div *ngIf="!onlyStreams" class="text-right hidden md:block" [mat-sort-header]="'creations'" arrowPosition="before">
                    {{t('creations')}}
                </div>
                <div *ngIf="!onlyStreams" class="text-right" [mat-sort-header]="'revenue'" arrowPosition="before">
                    {{t('revenue')}}
                </div>
                <div *ngIf="!onlyStreams && showPPS" class="text-right hidden lg:block" [mat-sort-header]="'pps'" arrowPosition="before">
                    {{t('cpm')}}
                </div>
                <div class="text-right hidden lg:block">
                    %
                </div>
            </div>
            <div *ngIf="!enableSort && !socials" [ngClass]="{'inventory-grid': showPPS, 'inventory-grid-no-pps': !showPPS}"
                class="z-10 sticky top-0 grid gap-4 py-4 px-4 sm:px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                <div></div>
                <div class="hidden lg:block"></div>
                <div></div>
                <div>
                    {{t('title')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('streams')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('downloads')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('creations')}}
                </div>
                <div class="text-right">
                    {{t('revenue')}}
                </div>
                <div *ngIf="showPPS" class="text-right hidden lg:block">
                    {{t('cpm')}}
                </div>
                <div class="text-right hidden lg:block">
                    %
                </div>
            </div>
            <div *ngIf="socials && (storeName === 'TikTok' || !storeName)"
                class="inventory-grid-socials z-10 sticky top-0 grid gap-4 py-4 px-4 sm:px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                <div class="hidden md:block"></div>
                <div class="hidden sm:block"></div>
                <div>
                    {{t('title')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('creations')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('video-views')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('likes')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('comments')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('shares')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('favorites')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('avg-watch-time')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('revenue')}}
                </div>
                <div class="text-right hidden lg:block">
                    %
                </div>
            </div>
            <div *ngIf="socials && storeName === 'YouTube'"
                class="inventory-grid-socials-youtube z-10 sticky top-0 grid gap-4 py-4 px-4 sm:px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                <div class="hidden md:block"></div>
                <div class="hidden sm:block"></div>
                <div>
                    {{t('title')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('video-views')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('likes')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('comments')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('shares')}}
                </div>
                <div class="text-right hidden lg:block">
                    {{t('avg-watch-time')}}
                </div>
                <div class="text-right hidden md:block">
                    {{t('revenue')}}
                </div>
                <div class="text-right hidden lg:block">
                    %
                </div>
            </div>

            <!-- Rows -->
            <ng-container *ngIf="data?.length > 0; else noData">
                <ng-container *ngIf="!socials">
                    <ng-container *ngFor="let row of data; let i = index">
                        <ng-container [ngTemplateOutlet]="tableRow" [ngTemplateOutletContext]="{row: row, i: i, totalsRow: false}"></ng-container>
                    </ng-container>
                    <ng-container [ngTemplateOutlet]="tableRow" [ngTemplateOutletContext]="{row: getTotalsRow(), i: data.length, totalsRow: true}"></ng-container>
                </ng-container>
                <ng-container *ngIf="socials && (storeName === 'TikTok' || !storeName)">
                    <ng-container *ngFor="let row of data; let i = index">
                        <ng-container [ngTemplateOutlet]="socialsRow" [ngTemplateOutletContext]="{row: row, i: i, totalsRow: false}"></ng-container>
                    </ng-container>
                    <ng-container [ngTemplateOutlet]="socialsRow" [ngTemplateOutletContext]="{row: getTotalsRow(), i: data.length, totalsRow: true}"></ng-container>
                </ng-container>
                <ng-container *ngIf="socials && storeName === 'YouTube'">
                    <ng-container *ngFor="let row of data; let i = index">
                        <ng-container [ngTemplateOutlet]="socialsRowYT" [ngTemplateOutletContext]="{row: row, i: i, totalsRow: false}"></ng-container>
                    </ng-container>
                    <ng-container [ngTemplateOutlet]="socialsRowYT" [ngTemplateOutletContext]="{row: getTotalsRow(), i: data.length, totalsRow: true}"></ng-container>
                </ng-container>
            </ng-container>
            <ng-template #noData>
                <div
                    class="flex flex-col h-full justify-center p-8 sm:p-16 border-t text-2xl font-semibold tracking-tight text-center">
                    {{t("no-data-found")}}</div>
            </ng-template>

            <ng-template #socialsRow let-row="row" let-i="i" let-totalsRow="totalsRow">
                <div [ngClass]="{'shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5': totalsRow}"
                        class="grid inventory-grid-socials items-center gap-4 py-1 px-4 sm:px-6 md:px-8 border-b">
                        <button *ngIf="showMoreButton && i === data.length - 1" class="centered-button" mat-flat-button
                            color="primary" (debounceClick)="moreRows()" [debounceTime]="3000" appDebounceClick>
                            <mat-icon class="mr-2">arrow_drop_down</mat-icon>
                            {{'show-more' | transloco}}
                        </button>

                        <div *ngIf="!totalsRow" class="items-center hidden md:block">
                            {{i > -1 ? i + 1 : ''}}.
                        </div>
                        <div *ngIf="totalsRow" class="hidden md:block"></div>

                        <div class="items-center hidden sm:flex">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 rounded">
                                <img *ngIf="row.metadata.artwork" [alt]="'Artwork'"
                                    [src]="platformService.getFileSrc(row.metadata.artwork, 'artwork')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.logo" [alt]="'Logo'"
                                    [src]="platformService.getFileSrc(row.metadata.logo, 'logo')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.avatar?.fileName" [alt]="'User avatar'"
                                    [src]="platformService.getFileSrc(row.metadata.avatar, 'avatar')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.country" [alt]="'Country flag'"
                                    [src]="row.metadata.country.flagImage" class="w-full h-full object-contain">
                                    <ng-container *ngIf="!row.metadata.artwork && !row.metadata.logo && !row.metadata.avatar?.fileName && !row.metadata.country && row.metadata?.title !== 'Total' && !row.metadata?.title?.startsWith('Others')">
                                        <div
                                            class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                            {{row.metadata?.title?.charAt(0) ?? "?"}}
                                        </div>
                                    </ng-container>
                            </div>
                        </div>

                        <div class="truncate">
                            <div class="flex justify-between">
                                <a class="text-lg "
                                    [ngClass]="{'hover:text-primary hover:cursor-pointer': row.metadata.title !== 'Others (Total)'&& !disableFilterOnClick}"
                                    (click)="row.metadata.title !== 'Others (Total)' && !disableFilterOnClick ? addFilter(row.metadata) : ''">
                                    {{row.metadata.title ?? row.metadata.uuid ?? "Unknown"}}
                                </a>
                            </div>
                            <div class="block text-base text-gray-500">
                                {{row.metadata.subTitle}}
                            </div>

                        </div>

                        <div class="text-right hidden md:block">
                            {{(row.totals?.creations ? row.totals.creations : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden md:block">
                            {{(row.totals?.streams ? row.totals.streams : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.likes ? row.totals.likes : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.comments ? row.totals.comments : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.shares ? row.totals.shares : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.favorites ? row.totals.favorites : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.avg_duration ? row.totals.avg_duration : 0) | number: '1.2-2'}}s
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.revenue ? row.totals.revenue : 0) | currency:currency:'symbol':'1.2-2'}}
                        </div>

                        <div class="hidden lg:block text-right">
                            {{!onlyStreams ? getPercentageString(row.totals?.revenue, totalRevenue) : getPercentageString(row.totals?.streams, totalStreams)}}
                        </div>
                    </div>
            </ng-template>

            <ng-template #socialsRowYT let-row="row" let-i="i" let-totalsRow="totalsRow">
                <div [ngClass]="{'shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5': totalsRow}"
                        class="grid inventory-grid-socials-youtube items-center gap-4 py-1 px-4 sm:px-6 md:px-8 border-b">
                        <button *ngIf="showMoreButton && i === data.length - 1" class="centered-button" mat-flat-button
                            color="primary" (debounceClick)="moreRows()" [debounceTime]="3000" appDebounceClick>
                            <mat-icon class="mr-2">arrow_drop_down</mat-icon>
                            {{'show-more' | transloco}}
                        </button>

                        <div *ngIf="!totalsRow" class="items-center hidden md:block">
                            {{i > -1 ? i + 1 : ''}}.
                        </div>
                        <div *ngIf="totalsRow" class="hidden md:block"></div>

                        <div class="items-center hidden sm:flex">
                            <div class="relative flex flex-0 items-center justify-center w-30 mr-6 rounded" [ngClass]="{'h-24': row.metadata.video, 'h-14': !row.metadata.video}">
                                <img *ngIf="row.metadata.artwork" [alt]="'Artwork'"
                                    [src]="platformService.getFileSrc(row.metadata.artwork, 'artwork')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.thumbnail" [alt]="'Thumbnail'"
                                    [src]="row.metadata.thumbnail"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.logo" [alt]="'Logo'"
                                    [src]="platformService.getFileSrc(row.metadata.logo, 'logo')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.avatar?.fileName" [alt]="'User avatar'"
                                    [src]="platformService.getFileSrc(row.metadata.avatar, 'avatar')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.country" [alt]="'Country flag'"
                                    [src]="row.metadata.country.flagImage" class="w-full h-full object-contain">
                                    <ng-container *ngIf="!row.metadata.artwork && !row.metadata.thumbnail && !row.metadata.logo && !row.metadata.avatar?.fileName && !row.metadata.country && row.metadata?.title !== 'Total' && !row.metadata?.title?.startsWith('Others')">
                                        <div
                                            class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                            {{row.metadata?.title?.charAt(0) ?? "?"}}
                                        </div>
                                    </ng-container>
                            </div>
                        </div>

                        <div class="">
                            <div class="flex justify-between">
                                <a class="text-lg "
                                    [ngClass]="{'hover:text-primary hover:cursor-pointer': row.metadata.title !== 'Others (Total)'}"
                                    (click)="(row.metadata.title !== 'Others (Total)' ? ( row.metadata.video?.videoId ? openVideo(row.metadata.video.videoId) : addFilter(row.metadata)) : '')">
                                    {{row.metadata.title ?? row.metadata.uuid ?? "Unknown"}}
                                    <span *ngIf="row.metadata?.isShort"
                                        class="inline-flex items-center font-bold text-xs ml-2 px-2.5 py-0.5 rounded-full tracking-wide uppercase bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50">
                                        <span class="leading-relaxed whitespace-nowrap">
                                            SHORT
                                        </span>
                                    </span>
                                </a>

                            </div>
                            <div class="block text-base text-gray-500">
                                {{row.metadata.subTitle}}
                            </div>

                        </div>

                        <div class="text-right hidden md:block">
                            {{(row.totals?.streams ? row.totals.streams : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.likes ? row.totals.likes : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.comments ? row.totals.comments : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.shares ? row.totals.shares : 0) | number: '1.0-0'}}
                        </div>

                        <div class="text-right hidden lg:block">
                            {{(row.totals?.avg_duration ? row.totals.avg_duration : 0) | duration}}
                        </div>

                        <div class="text-right hidden md:block">
                            {{(row.totals?.revenue ? row.totals.revenue : 0) | currency:currency:'symbol':'1.2-2'}}
                        </div>

                        <div class="hidden lg:block text-right">
                            {{!onlyStreams ? getPercentageString(row.totals?.revenue, totalRevenue) : getPercentageString(row.totals?.streams, totalStreams)}}
                        </div>
                    </div>
            </ng-template>

            <ng-template #tableRow let-row="row" let-i="i" let-totalsRow="totalsRow">
                <div [ngClass]="{'inventory-grid': !onlyStreams && showPPS, 'inventory-grid-no-pps': !onlyStreams && !showPPS, 'inventory-grid-only-streams': onlyStreams, 'shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5': totalsRow}"
                        class="grid items-center gap-4 py-1 px-4 sm:px-6 md:px-8 border-b">
                        <button *ngIf="showMoreButton && i === data.length - 1" class="centered-button" mat-flat-button
                            color="primary" (debounceClick)="moreRows()" [debounceTime]="3000" appDebounceClick>
                            <mat-icon class="mr-2">arrow_drop_down</mat-icon>
                            {{'show-more' | transloco}}
                        </button>

                        <div class="flex items-center">
                            <div *ngIf="!totalsRow" [ngStyle]="{'background-color': getColorForIndex(i)}" class="chart-color-circle"></div>
                        </div>
                        <div *ngIf="!totalsRow" class="items-center hidden lg:block">
                            {{i > -1 ? i + 1 : ''}}.
                        </div>
                        <div *ngIf="totalsRow" class="hidden lg:block"></div>

                        <div class="flex items-center">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 rounded">
                                <img *ngIf="row.metadata.artwork" [alt]="'Artwork'"
                                    [src]="platformService.getFileSrc(row.metadata.artwork, 'artwork')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.logo" [alt]="'Logo'"
                                    [src]="platformService.getFileSrc(row.metadata.logo, 'logo')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.avatar?.fileName" [alt]="'User avatar'"
                                    [src]="platformService.getFileSrc(row.metadata.avatar, 'avatar')"
                                    class="w-full h-full object-contain">
                                <img *ngIf="row.metadata.country" [alt]="'Country flag'"
                                    [src]="row.metadata.country.flagImage" class="w-full h-full object-contain">
                                    <ng-container *ngIf="!row.metadata.artwork && !row.metadata.logo && !row.metadata.avatar?.fileName && !row.metadata.country && row.metadata?.title !== 'Total' && !row.metadata?.title?.startsWith('Others')">
                                        <div
                                            class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                            {{row.metadata?.title?.charAt(0) ?? "?"}}
                                        </div>
                                    </ng-container>
                            </div>
                        </div>

                        <div class="truncate">
                            <div class="flex justify-between">
                                <a class="text-lg "
                                    [ngClass]="{'hover:text-primary hover:cursor-pointer': row.metadata.title !== 'Others (Total)'&& !disableFilterOnClick}"
                                    (click)="row.metadata.title !== 'Others (Total)' && !disableFilterOnClick ? addFilter(row.metadata) : ''">
                                    {{row.metadata.title ?? row.metadata.uuid ?? "Unknown"}}
                                </a>
                            </div>
                            <div class="block text-base text-gray-500">
                                {{row.metadata.subTitle}}
                            </div>

                        </div>

                        <div class="text-right hidden md:block">
                            {{(row.totals?.streams) | number: '1.0-0'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.streams, comparison:row.comparison?.streams}">
                            </ng-container>
                        </div>

                        <div *ngIf="!onlyStreams" class="text-right hidden md:block">
                            {{(row.totals?.downloads) | number: '1.0-0'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.downloads, comparison:row.comparison?.downloads}">
                            </ng-container>
                        </div>

                        <div *ngIf="!onlyStreams" class="text-right hidden md:block">
                            {{(row.totals?.creations) | number: '1.0-0'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.creations, comparison:row.comparison?.creations}">
                            </ng-container>
                        </div>

                        <div *ngIf="!currency && !onlyStreams" class="text-right">
                            {{(row.totals?.revenue) |
                            currency:platform.currency:'symbol':'1.2-2'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.revenue, comparison:row.comparison?.revenue, currency:platform.currency}">
                            </ng-container>
                        </div>
                        <div *ngIf="currency && !onlyStreams" class="text-right">
                            {{(row.totals?.revenue) | currency:currency:'symbol':'1.2-2'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.revenue, comparison:row.comparison?.revenue, currency:currency}">
                            </ng-container>
                        </div>

                        <div *ngIf="showPPS && !currency && !onlyStreams" class="text-right hidden lg:block">
                            {{(row.totals?.pps) * 1000 |
                            currency:platform.currency:'symbol':'1.2-2'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.pps ? row.totals.pps * 1000 : null, comparison:row.comparison?.pps ? (row.comparison?.pps) * 1000 : null, currency:platform.currency}">
                            </ng-container>
                        </div>
                        <div *ngIf="showPPS && currency && !onlyStreams" class="text-right hidden lg:block">
                            {{(row.totals?.pps) * 1000 | currency:currency:'symbol':'1.2-2'}}
                            <ng-container [ngTemplateOutlet]="comparisonView"
                                [ngTemplateOutletContext]="{data:row.totals?.pps ? row.totals.pps * 1000 : null, comparison:row.comparison?.pps ? (row.comparison?.pps) * 1000 : null, currency:currency}">
                            </ng-container>
                        </div>

                        <div class="hidden lg:block text-right">
                            {{!onlyStreams ? getPercentageString(row.totals?.revenue, totalRevenue) : getPercentageString(row.totals?.streams, totalStreams)}}
                        </div>
                    </div>
            </ng-template>

            <ng-template #comparisonView let-data='data' let-comparison="comparison" let-currency="currency">
                <div *ngIf="comparison !== undefined && comparison !== null && comparisonMode !== 'artificials'" [matTooltip]="formatComparisonTooltip(comparison, currency)">
                    <div *ngIf="data === comparison" class="block text-gray-500 text-sm">-</div>
                    <div *ngIf="data > comparison" class="block text-green-500 text-sm">
                        +{{getComparisonPercentageString(data, comparison)}}</div>
                    <div *ngIf="data < comparison" class="block text-red-500 text-sm">
                        {{getComparisonPercentageString(data, comparison)}}</div>
                </div>
                <div *ngIf="comparison !== undefined && comparison !== null && comparisonMode === 'artificials'" [matTooltip]="formatComparisonTooltip(comparison, currency)">
                    <div class="block text-red-500 text-sm">
                        {{getArtificialsComparisonPercentageString(data, comparison)}}</div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>
